import { INomenklatureItem, NomenklatureInterface, Width } from "../store/types/store";

export class Nomenklature implements NomenklatureInterface {
    connector = 0;
    horizontal = new NomenklatureItem();
    vertical = new NomenklatureItem();
}

export class NomenklatureItem implements INomenklatureItem {
    [Width.FOUR_HUNDRED_EIGHTY] = 0;
    [Width.SIX_HUNDRED] = 0;
    [Width.EIGHT_HUNDRED] = 0;
    [Width.ONE_THOUSAND_TWO_HUNDRED] = 0;
}
